howspace.components.fileUploader = (() => {
    'use strict';

    const getFileUploader = e => {
        if (e.target.classList.contains('howspace-file-uploader')) {
            return e.target;
        }
        return e.target.closest('.howspace-file-uploader') || null;
    };

    const allowsPaste = fileUploader => fileUploader.dataset.allowPaste !== 'false';

    const getFilePreview = notification => {
        const token = notification.object.uploadedfile?.upload_process_metadata?.token;
        return document.querySelector('.howspace-file-uploader-preview[data-upload-token="' + token + '"]');
    };

    const checkIfFileUploadCompleted = fileUploader => {
        const uploadedFiles = [];
        let fileUploadCompleted = true;
        fileUploader.querySelectorAll('.howspace-file-uploader-preview').forEach(filePreview => {
            if (filePreview.dataset.isStored === 'true') {
                uploadedFiles.push(JSON.parse(filePreview.dataset.uploadedFile));
                return;
            }
            fileUploadCompleted = false;
        });

        if (fileUploadCompleted) {
            howspace.dispatchEvent(fileUploader, howspace.components.fileUploader.UPLOAD_COMPLETED, {
                uploadedFiles: uploadedFiles
            });
        }
    };

    real.onTierReady(real.TIER_2, () => {
        real.events.on('uploadedfile:content_type_identified', notification => {
            const filePreview = getFilePreview(notification);
            if (filePreview === null) {
                // Did not find the file preview from the DOM.
                return;
            }

            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_file_stored') +
                ` (${notification.object.uploadedfile.mime_type})...`;
        });

        real.events.on('uploadedfile:stored', notification => {
            const filePreview = getFilePreview(notification);
            if (filePreview === null) {
                // Did not find the file preview from the DOM.
                return;
            }

            filePreview.dataset.isStored = true;

            const fileUploader = filePreview.closest('.howspace-file-uploader');
            if (fileUploader === null) {
                // Did not find the file uploader from the DOM.
                return;
            }

            filePreview.dataset.uploadedFile = JSON.stringify(notification.object.uploadedfile);
            filePreview.dataset.uploadedFileId = notification.object.uploadedfile.id;
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_file_stored') + `!`

            checkIfFileUploadCompleted(fileUploader);
        });

        real.events.on('uploadedfile:invalid_content_type_type', notification => {
            const filePreview = getFilePreview(notification);
            if (filePreview === null) {
                // Did not find the file preview from the DOM.
                return;
            }

            filePreview.classList.add('has-error');
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_error_invalid_content_type') +
                ` (${notification.object.uploadedfile.mime_type})`;
        });

        real.events.on('uploadedfile:failed', function (notification) {
            const filePreview = getFilePreview(notification);
            if (filePreview === null) {
                // Did not find the file preview from the DOM.
                return;
            }

            const fileUploader = filePreview.closest('.howspace-file-uploader');
            if (fileUploader === null) {
                // Did not find the file uploader from the DOM.
                return;
            }

            filePreview.classList.add('has-error');
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_errors') +
                ` (${notification.object.uploadedfile.upload_process_metadata.error_msg})`

        });
    });

    const startFileUploads = (fileUploader, files) => {
        if (files.length > 1 && fileUploader.dataset.allowMultiple !== 'true') {
            // User is trying to upload multiple files, but only one is allowed.
            fileUploader.querySelector('.too-many-files-alert').classList.remove('d-none');
            return;
        }

        // Hide the form, show the progress.
        fileUploader.querySelector('.too-many-files-alert').classList.add('d-none');
        fileUploader.querySelector('.howspace-file-uploader-form').classList.add('d-none');
        fileUploader.querySelector('.howspace-file-uploader-progress').classList.remove('d-none');

        // Loop through all files and append previews.
        Array.prototype.forEach.call(files, file => {
            appendFilePreview(fileUploader, file);
        });
    };

    const isFileTypeAllowed = (fileUploader, file) => {
        const allowedContentTypes = fileUploader.querySelector('.howspace-file-input')?.getAttribute('accept') || '';

        if (!allowedContentTypes) {
            return true;
        }

        const fileType = file.type || '';
        const fileName = (file.name || '').toLowerCase();
        let isAllowed = false;
        allowedContentTypes.split(',').forEach((contentType) => {
            contentType = contentType.trim().toLowerCase();
            if (contentType.startsWith('.')) {
                if (fileName.endsWith(contentType)) {
                    isAllowed = true;
                }
                return;
            }
            if (contentType.endsWith('*')) {
                // Content type ends with asterisk (*), in this case it's enough if the fileType
                // begins with the content type (disregarding the * at the end).
                if (fileType.toLowerCase().startsWith(contentType.slice(0, -1))) {
                    isAllowed = true;
                }
            } else if (fileType.toLowerCase() === contentType) {
                isAllowed = true;
            }
        });
        return isAllowed;
    };

    const appendFilePreview = (fileUploader, file) => {
        // Append a new file upload preview element.
        const progress = fileUploader.querySelector('.howspace-file-uploader-progress');
        const uploadToken = real.uid();
        const uid = 'howspace-file-upload-' + uploadToken;
        const deleteBtn = howspace.template.getHtml(fileUploader.querySelector('template.howspace-file-delete-btn'));
        const filePreview = document.createElement('div');
        filePreview.id = uid;
        filePreview.dataset.source = fileUploader.dataset.source;
        filePreview.dataset.uploadToken = uploadToken;
        filePreview.dataset.isStored = false;
        filePreview.classList.add('howspace-file-uploader-preview');
        filePreview.innerHTML = `
            <div class="howspace-file-uploader-preview-icon"></div>
            <div class="howspace-file-uploader-preview-content">
                <div class="howspace-file-uploader-preview-progress-bar-bg">
                    <div class="howspace-file-uploader-preview-progress-bar"></div>
                </div>
                <div class="howspace-file-uploader-preview-progress-text">
                    Uploading <span class="percentage">0</span>%
                </div>
            </div>
            <div class="howspace-file-uploader-preview-delete self-center px-3">${deleteBtn}</div>
        `;
        progress.appendChild(filePreview);

        const previewIcon = filePreview.querySelector('.howspace-file-uploader-preview-icon');

        if (!isFileTypeAllowed(fileUploader, file)) {
            // File content type is not allowed.
            filePreview.classList.add('has-error');
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_error_invalid_content_type') + ` (${file.type})`
        } else if (file.size > fileUploader.dataset.maxFileSize) {
            // File is too big.
            filePreview.classList.add('has-error');
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_error_too_big_file')
                    .replace('%max%', fileUploader.dataset.humanReadableMaxFileSize);
        } else {
            // No errors, start uploading the file.
            startSingleFileUpload(fileUploader, file, uploadToken);
        }

        if (file.type.startsWith('image/')) {
            // Image.
            const reader = new FileReader();
            reader.onload = e => {
                previewIcon.style.backgroundImage = `url("${e.target.result}")`;
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith('video/')) {
            // Video.
            previewIcon.innerHTML = `
                <video>
                    <source type="${file.type}" src="${URL.createObjectURL(file)}">
                </video>
            `;
        } else if (file.type === 'text/plain') {
            // Plain text.
            previewIcon.innerHTML = fileUploader.querySelector('.file-type-icons .file-type-text').outerHTML;
        } else if (file.type === 'application/pdf') {
            // PDF.
            previewIcon.innerHTML = fileUploader.querySelector('.file-type-icons .file-type-pdf').outerHTML;
        } else {
            // Generic file type.
            previewIcon.innerHTML = fileUploader.querySelector('.file-type-icons .file-type-other').outerHTML;
        }
    };

    const translateError = (fileUploader, filePreview, response) => {
        /**
         * https://www.php.net/manual/en/features.file-upload.errors.php
         *
         * 0 => 'There is no error, the file uploaded with success',
         * 1 => 'The uploaded file exceeds the upload_max_filesize directive in php.ini',
         * 2 => 'The uploaded file exceeds the MAX_FILE_SIZE directive that was specified in the HTML form',
         * 3 => 'The uploaded file was only partially uploaded',
         * 4 => 'No file was uploaded',
         * 6 => 'Missing a temporary folder',
         * 7 => 'Failed to write file to disk.',
         * 8 => 'A PHP extension stopped the file upload.',
         */

        if (response.status === 0) {
            // Upload failed due to a network error.
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_error_network_failed');
            return;
        }

        let unknownError = true;
        real.ajax.loopErrors(response, error => {
            let errorCode = parseInt(error.key.split('_').pop());

            if (isNaN(errorCode)) {
                errorCode = '"' + error.key + '"';
            }

            if (error.key === 'filename_too_long') {
                unknownError = false;
                filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                    howspace.translate('fileuploader_error_filename_too_long')
                        .replace('%max%', fileUploader.dataset.maxFilenameLength);
            } else if (errorCode === 1 || errorCode === 2) {
                // User uploaded a file that is too big.
                unknownError = false;
                filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                    howspace.translate('fileuploader_error_too_big_file')
                        .replace('%max%', fileUploader.dataset.humanReadableMaxFileSize);
            } else {
                unknownError = false;
                filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                    howspace.translate('fileuploader_error_upload_failed')
                        .replace('%code%', error.message || errorCode);
            }
        });

        if (unknownError) {
            filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                howspace.translate('fileuploader_unknown_error')
        }
    };

    const startSingleFileUpload = (fileUploader, file, uploadToken) => {
        const formData = new FormData();

        // Put max file size to the form data.
        const maxFileSize = fileUploader.dataset.maxFileSize;
        if (maxFileSize) {
            formData.append('MAX_FILE_SIZE', maxFileSize);
        }

        // Append the upload token to the form data.
        formData.append('upload_process_metadata', JSON.stringify({
            token: uploadToken
        }));

        // Append the file to the form data.
        formData.append('file', file);

        // Get URL from data attributes or use default fallback.
        const uri = fileUploader.dataset.uri || '/api/uploadedfiles';

        real.ajax(real.baseUri + uri, {
            type: 'POST',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            xhr: () => {
                const xhr = new XMLHttpRequest();

                xhr.upload.addEventListener('progress', e => {
                    if (e.lengthComputable) {
                        const progress = e.loaded / e.total * 100;
                        const preview = fileUploader.querySelector('#howspace-file-upload-' + uploadToken);
                        const progressBar = preview.querySelector('.howspace-file-uploader-preview-progress-bar');
                        const progressText = preview.querySelector('.howspace-file-uploader-preview-progress-text');
                        progressBar.style.width = progress + '%';
                        progressText.querySelector('.percentage').innerHTML = '' + Math.floor(progress);
                    }
                }, false);

                return xhr;
            },
            success: () => {
                const filePreview = document.querySelector('.howspace-file-uploader-preview[data-upload-token="' + uploadToken + '"]');
                if (filePreview) {
                    filePreview.querySelector('.howspace-file-uploader-preview-progress-text').innerHTML =
                        howspace.translate('fileuploader_processing_file') + `...`
                }
            },
            logError: false,
            showErrorNotification: false,
            error: response => {
                const filePreview = fileUploader.querySelector('#howspace-file-upload-' + uploadToken);
                filePreview.classList.add('has-error');
                translateError(fileUploader, filePreview, response);
                checkIfFileUploadCompleted(fileUploader);
            }
        });
    };

    const handleClick = e => {
        // "Click" the file input.
        getFileUploader(e).querySelector('.howspace-file-input').click();
    };

    const handleChange = e => {
        const fileUploader = getFileUploader(e);
        startFileUploads(fileUploader, e.target.files);
    };

    const handleDrag = e => {
        e.preventDefault();
    };

    const handleDragOver = e => {
        const form = getFileUploader(e).querySelector('.howspace-file-uploader-form');
        if (!form.classList.contains('uploading')) {
            form.classList.add('drag-over');
        }
    };

    const handleDragLeave = e => {
        const form = getFileUploader(e).querySelector('.howspace-file-uploader-form');
        form.classList.remove('drag-over');
    };

    const handleDrop = e => {
        const fileUploader = getFileUploader(e);
        const form = fileUploader.querySelector('.howspace-file-uploader-form');
        form.classList.remove('drag-over');
        startFileUploads(fileUploader, e.dataTransfer.files);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const fileUploader = getFileUploader(e);
        const items = e.clipboardData.items;
        const files = [];
        for (let index in items) {
            const item = items[index];
            if (item.kind === 'file') {
                files.push(item.getAsFile());
            }
        }
        if (files.length > 0) {
            startFileUploads(fileUploader, files);
        }
    };

    return {
        UPLOAD_COMPLETED: 'howspace-file-uploader-upload-completed',
        init: elem => {
            elem.findIncludingSelf('.howspace-file-uploader:not(.howspace-file-uploader-initialized)').each(function () {
                const fileUploader = this;
                const $fileUploader = $(this);

                fileUploader.classList.add('howspace-file-uploader-initialized');

                if (howspace.isMobile()) {
                    fileUploader.classList.add('is-mobile');
                }

                $fileUploader.on('click', '.howspace-file-delete-btn', (e) => {
                    const preview = e.currentTarget.closest('.howspace-file-uploader-preview');
                    const progress = preview.closest('.howspace-file-uploader-progress');
                    preview.remove();
                    if (progress.querySelector('.howspace-file-uploader-preview:not(.has-error)') === null) {
                        // No more valid files left.
                        howspace.components.fileUploader.reset($fileUploader);
                        $fileUploader.find('input[type="file"].howspace-file-input').val('');
                    }
                });

                // Put focus to the input.
                if (elem.findIncludingSelf('.howspace-file-uploader').length === 1) {
                    fileUploader.querySelector('.howspace-form-text-input')?.focus();
                }

                // When clicking the button -> trigger click on the file input.
                const fileButton = fileUploader.querySelector('.howspace-file-button');
                fileButton.addEventListener('click', handleClick);

                // Browsing files.
                const fileInput = fileUploader.querySelector('.howspace-file-input');
                fileInput.addEventListener('change', handleChange);

                // Pasting files.
                if (allowsPaste(fileUploader)) {
                    fileUploader.addEventListener('paste', handlePaste);
                }

                // Drag events.
                const form = fileUploader.querySelector('.howspace-file-uploader-form');
                ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(dragEvent => {
                    form.addEventListener(dragEvent, handleDrag);
                });

                // Drag over events.
                ['dragover', 'dragenter'].forEach(dragOverEvent => {
                    form.addEventListener(dragOverEvent, handleDragOver);
                });

                // Drag leave events.
                ['dragleave', 'dragend'].forEach(dragLeaveEvent => {
                    form.addEventListener(dragLeaveEvent, handleDragLeave);
                });

                // Drop.
                form.addEventListener('drop', handleDrop);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-file-uploader.howspace-file-uploader-initialized').each(function () {
                const fileUploader = this;

                fileUploader.classList.remove('howspace-file-uploader-initialized');

                // When clicking the button -> trigger click on the file input.
                const fileButton = fileUploader.querySelector('.howspace-file-button');
                fileButton.removeEventListener('click', handleClick);

                // Browsing files.
                const fileInput = fileUploader.querySelector('.howspace-file-input');
                fileInput.removeEventListener('change', handleChange);

                // Pasting files.
                if (allowsPaste(fileUploader)) {
                    fileUploader.removeEventListener('paste', handlePaste);
                }

                // Drag events.
                const form = fileUploader.querySelector('.howspace-file-uploader-form');
                ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(dragEvent => {
                    form.removeEventListener(dragEvent, handleDrag);
                });

                // Drag over events.
                ['dragover', 'dragenter'].forEach(dragOverEvent => {
                    form.removeEventListener(dragOverEvent, handleDragOver);
                });

                // Drag leave events.
                ['dragleave', 'dragend'].forEach(dragLeaveEvent => {
                    form.removeEventListener(dragLeaveEvent, handleDragLeave);
                });

                // Drop.
                form.removeEventListener('drop', handleDrop);
            });
        },
        reset : elem => {
            elem.findIncludingSelf('.howspace-file-uploader').each(function () {
                const fileUploader = this;

                fileUploader.querySelector('.too-many-files-alert').classList.add('d-none');
                fileUploader.querySelector('.howspace-file-uploader-form').classList.remove('d-none');
                fileUploader.querySelector('.howspace-file-uploader-progress').classList.add('d-none');
                fileUploader.querySelector('.howspace-file-uploader-progress').innerHTML = '';
                fileUploader.querySelector('.howspace-file-input').value = '';
            });
        },
        startFileUploads: startFileUploads,
    };

})();
